import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

export default function setup() {
    Fancybox.bind('[data-fancybox]', {
        // Custom options for all galleries
        backFocus: false
    });
}